// removed by extract-text-webpack-plugin
module.exports = {"block":"Y3sv3MvOdUax7LXfDasem"};


//////////////////
// WEBPACK FOOTER
// ./src/css/screens/notfound.css
// module id = 336
// module chunks = 0